// @flow

import _ from 'lodash';
import type {
  FilterTreeState,
  FilterTreeAction
} from 'stores/flow-type/filter-tree/filter-tree.type';

import {
  GET_FILTER_TREE_REQUEST,
  GET_FILTER_TREE_SUCCESS,
  GET_FILTER_TREE_FAILURE,
  CREATE_FILTER_TREE_REQUEST,
  CREATE_FILTER_TREE_SUCCESS,
  CREATE_FILTER_TREE_FAILURE,
  UPDATE_FILTER_TREE_REQUEST,
  UPDATE_FILTER_TREE_SUCCESS,
  UPDATE_FILTER_TREE_FAILURE,
  GET_ALL_FILTER_OPTIONS_REQUEST,
  GET_ALL_FILTER_OPTIONS_SUCCESS,
  GET_ALL_FILTER_OPTIONS_FAILURE
} from 'stores/flow-type/filter-tree/filter-tree.type';

const initialState: FilterTreeState = {
  loading: false,
  loadingSave: false,
  success: false,
  successSave: false,
  error: undefined,
  filterTree: {},
  allFilterOptions: [],
  scheduleSyncInfo: {}
};

const filterTreeReducers = (state: FilterTreeState = initialState, action: FilterTreeAction) => {
  switch (action.type) {
    case GET_FILTER_TREE_REQUEST:
    case GET_ALL_FILTER_OPTIONS_REQUEST:
      return { ...state, loading: true, success: false };

    case CREATE_FILTER_TREE_REQUEST:
    case UPDATE_FILTER_TREE_REQUEST:
      return { ...state, loadingSave: true, successSave: false };

    case GET_FILTER_TREE_SUCCESS: {
      const { data } = action.payload;
      let { filterId, collections } = data;

      collections = _.map(collections, item => ({ value: item.id, label: item.title }));

      const filterTree = { ...state.filterTree, [filterId]: { ...data, collections } };

      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        filterTree
      };
    }
    case CREATE_FILTER_TREE_SUCCESS: {
      let {
        filterTree,
        createdFilterTree = {},
        scheduleSyncIn,
        scheduleSyncAfter,
        waitSyncAt
      } = action.payload;
      const filterId = _.get(createdFilterTree, 'filterId', '');
      const filterTreeNew = { ...state.filterTree, [filterId]: { ...filterTree, filterId } };
      const scheduleSyncInfo = { scheduleSyncIn, scheduleSyncAfter, waitSyncAt };
      const scheduleSyncInfoNew = { ...state.scheduleSyncInfo, [filterId]: scheduleSyncInfo };

      return {
        ...state,
        loadingSave: false,
        successSave: true,
        error: undefined,
        filterTree: filterTreeNew,
        scheduleSyncInfo: scheduleSyncInfoNew
      };
    }
    case UPDATE_FILTER_TREE_SUCCESS: {
      let { filterTree = {}, scheduleSyncIn, scheduleSyncAfter, waitSyncAt } = action.payload;

      const filterTreeNew = {
        ...state.filterTree,
        [filterTree.filterId]: filterTree
      };

      const scheduleSyncInfo = { scheduleSyncIn, scheduleSyncAfter, waitSyncAt };
      const scheduleSyncInfoNew = {
        ...state.scheduleSyncInfo,
        [filterTree.filterId]: scheduleSyncInfo
      };

      return {
        ...state,
        loadingSave: false,
        successSave: true,
        error: undefined,
        filterTree: filterTreeNew,
        scheduleSyncInfo: scheduleSyncInfoNew
      };
    }

    case GET_ALL_FILTER_OPTIONS_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...state,
        loading: false,
        success: true,
        error: undefined,
        allFilterOptions: data
      };
    }
    case GET_FILTER_TREE_FAILURE:
    case CREATE_FILTER_TREE_FAILURE:
    case UPDATE_FILTER_TREE_FAILURE:
    case GET_ALL_FILTER_OPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        loadingSave: false,
        success: false,
        successSave: false,
        error: action.payload
      };

    default:
      return state;
  }
};
export default filterTreeReducers;
